module.exports = __webpack_public_path__ + "img/add-file.511d6aea.svg";